export interface IFacettedListElement {
  element_id?: string;
  count?: number;
  depth?: number;
  isDisabled?: boolean;
  score?: number;
  core_hasListName?: string;
  core_hasOrder?: string;
  core_hasParentValue?: IFacettedListElement;
}

export class FacettedListElement implements IFacettedListElement {
  constructor(
    public element_id?: string,
    public count?: number,
    public depth?: number,
    public isDisabled?: boolean,
    public score?: number,
    public core_hasListName?: string,
    public core_hasOrder?: string,
    public core_hasParentValue?: IFacettedListElement
) {}
}